import { estaContido, validarQtdeCaractere } from './auxiliares';
import { useMetadadosItem } from './useMetadadosItem';

export const useMetadadosMetadescricao = () => {
  const criterios = [
    {
      texto: 'A meta description deve conter entre 160 e 320 caracteres',
      otimizado: false,
    },
    {
      texto: 'Este campo não pode estar vazio',
      otimizado: false,
    },
    {
      texto: 'A meta description deve conter a palavra-chave',
      otimizado: false,
    },
  ];

  function validacoes(index, metadescricao, palavraChave) {
    switch (index) {
      case 0:
        return validarQtdeCaractere(metadescricao, 160, 320);
      case 1:
        return metadescricao !== null && metadescricao !== undefined && metadescricao.length > 0;
      case 2:
        return estaContido(palavraChave, metadescricao);
    }
  }

  return useMetadadosItem({ itemCriterios: criterios, validacoesFn: validacoes });
};
